import React, { Component } from 'react';
import Navbar from '../Components/Navbar';
import ForgotPassword from '../Components/ForgotPassword/ForgotPassword';

class ForgotPasswordContainer extends Component {
    render() {
        return (
            <div>
                   <ForgotPassword history={this.props.history} />
            </div>
        )
    }
}

export default ForgotPasswordContainer;